/*
 * Вид снят с иконок шапки (prototype/Prototype.dc.html:176-211: колокол, шестерёнка, тема) —
 * единственного реального потребителя на момент правки. До Task 16 компонент существовал
 * только в виде `ThemeToggle`, который нигде не рендерился, поэтому старый вид (32px, панель
 * с рамкой) был непроверенной догадкой, а не образцом: перекрывать его классом снаружи вместо
 * того, чтобы поправить сам компонент, значило бы тащить два источника истины об одной кнопке.
 */
.root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  color: var(--ink-2);
  cursor: pointer;
}

.root:hover {
  background: var(--sunk);
}

.root.active {
  background: var(--accent-soft);
  color: var(--accent);
}
.root.active:hover {
  background: var(--accent-soft);
  color: var(--accent);
}

.root:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.root:disabled:hover {
  background: transparent;
}

/* Точка непрочитанного — колокол уведомлений (prototype/Prototype.dc.html:178), 1:1. */
.dot {
  position: absolute;
  top: 5px;
  right: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--accent);
  border: 1.5px solid var(--bg);
}
